// extracted by mini-css-extract-plugin
export default {"container":"EVSxEyFKukys35zCrXDScg==","title":"wjHS-FVly6nzOXyXk9wEkA==","list":"kOaU7qgeeAlPQ+irrWA6xQ==","list-item":"lLHLOGTYvu6mZn0mu+Pl5g==","image":"tymmaKPM0iNkFrxX8xtUuA=="};